import widgetTemplate from './templates/widget.handlebars';

app.modules.youtubeWidget = ((self = {}) => {
  const CONFIG = app.config.youtubeWidget;

  const SELECTORS = {
    widget: '.js-youtube-widget',
    list: '.js-youtube-widget-list',
    link: '.js-youtube-widget-link',
  };

  function _renderWidget(container, items) {
    let widget = document.createElement('div');

    items.map((item) => {
      item.snippet.title = item.snippet.title.replace(/&quot;/g, '"');
      item.snippet.title = item.snippet.title.replace(/&amp;/g, '&');
      return item;
    });

    widget.innerHTML = widgetTemplate({items, title: container.dataset.title});
    widget = widget.firstChild;
    container.parentNode.replaceChild(widget, container);

    $(widget.querySelector(SELECTORS.list)).contentslider({
      showScroll: false,
      countView: container.dataset.slidesCount,
      countSlide: container.dataset.slidesCount,
    });

    $(widget).find(SELECTORS.link).fancybox();
  }

  function _init() {
    const containers = document.querySelectorAll(SELECTORS.widget);

    containers.forEach((container) => {
      const queryParams = $.param({
        part: 'snippet',
        q: container.dataset.query,
        type: 'video',
        maxResults: CONFIG.maxResults,
        key: CONFIG.apiKey,
      });

      fetch(`${CONFIG.apiUrl}?${queryParams}`)
        .then((res) => res.json())
        .then((res) => {
          _renderWidget(container, res.items);
        })
        .catch((err) => {
          console.warn(err.stack);
        });
    });
  }

  self.load = _init;
  return self;
})(app.modules.youtubeWidget);
